module.exports = "https://cdn.realtymogul.com/static/media/HP_rightopps_city.bb761ee0.jpg";